export const CATCH_API_ERROR = 'CATCH_API_ERROR',
      SOCKET_INFO_REQUEST = 'SOCKET_INFO_REQUEST',
      AUTH_CHECK_SESSION = 'AUTH_CHECK_SESSION',
      GENERAL_SOCKET_INFO_REQUEST = 'GENERAL_SOCKET_INFO_REQUEST',
      SELECT_FILTER = 'SELECT_FILTER',
      CONSISTENT_MULTIPLE_ACTIONS = 'CONSISTENT_MULTIPLE_ACTIONS'
